import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import clsx from 'clsx'
import { fluidSize } from 'chaoskit/src/assets/styles/utility/misc'
import { darkBluePurple } from 'chaoskit/src/assets/styles/utility/gradient'

import FreeSignUp from './FreeSignUp'

import {
  StylesCTAGremlin,
  hangingGremlinVariables,
} from '~partials/global/ArticleCTA'

const FreeSignUpEmbed = ({
  type = 'tutorial',
  className,
  contrast,
  ...rest
}) => {
  const theme = useTheme()

  const INTRO_TYPES = {
    tutorial: 'Sign up now. Free forever.',
    blog: 'Run your first Chaos Experiment in minutes.',
  }

  return (
    <div
      css={[
        fluidSize({
          theme,
          property: 'padding',
          from: theme.space.base,
          to: theme.space.large,
        }),
        {
          boxShadow: theme.boxShadow.large,
          borderRadius: theme.borderRadius.large,
          position: 'relative',
          marginTop: hangingGremlinVariables.height,

          '&::before': StylesCTAGremlin,
        },

        !contrast && {
          border: theme.border.base,
        },

        contrast && darkBluePurple(theme),
      ]}
      className={clsx(className, {
        [theme.settings.classes.contrast]: contrast,
      })}
    >
      <FreeSignUp
        title="Create your Gremlin Free account"
        sub={INTRO_TYPES[type]}
        inline
        useGenericEmail
        {...rest}
      />
    </div>
  )
}

FreeSignUpEmbed.propTypes = {
  type: PropTypes.oneOf(['blog', 'tutorial']),
  contrast: PropTypes.bool,
  className: PropTypes.string,
}

export default FreeSignUpEmbed
